import { Event, MissedEvent } from '../interfaces';
import { humanizeEnum } from './humanizeEnum';

export const getSentToProcessorStatus = (event: Event | MissedEvent): string => {
  const status = event.evidence_status;

  if (event.evidence_delivered_at) {
    return 'Sent to processor';
  }

  if (event.human_review === false || event.human_review === null) {
    return humanizeEnum(status || 'Unprocessed');
  }

  return humanizeEnum(status || 'Queued');
};
